import { render } from "./SeccionMultiselect.vue?vue&type=template&id=824b46ba"
import script from "./SeccionMultiselect.vue?vue&type=script&lang=js"
export * from "./SeccionMultiselect.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__